import Axios from 'axios';

import SET_PROJECTS from './constants';
import { setCustomerContact } from '../../AddClient/Contact/actions';

import { setCustomer } from '../../AddClient/ClientInfo/actions';

import { setProjectAddress, setProjectName } from '../../common/projectaddress/actions';

import { setNYRebate } from '../../common/nyserda/actions';

import { setESS } from '../../common/ess/actions';

import { setLoan } from '../../common/loan/actions';

import { setOBS } from '../../common/obs/actions';

import { setCAP } from '../../common/cap/actions';

import { setPPA } from '../../common/ppa/actions';

import {
    setYearSliderChange,
    setToggleView,
} from '../../common/settings/actions';

import { setIsLocked } from '../../IsLocked/actions';

import { setIncludeCash } from '../../common/cash/actions';

import { setSMARTValue } from '../../common/smart/actions';

import { setSolarInputs } from '../../common/solar/actions';

import { setTaxInputs } from '../../common/tax/actions';

import {
    // setUtility,
    setUtilityAnnualKWH,
    setUtilityEnergyValue,
    setUtilityProvider,
    setUtilityAnnualInflation,
    setAFixedCharge,
} from '../../common/utility/actions';

import { setSalesRep } from '../../common/projectreps/actions';

import {
    setArchiveStatus,
    setJobStatus,
    setProjectToken,
} from '../../common/projectstatus/actions';

export const setProjects = projects => ({
    type: SET_PROJECTS,
    projects,
});


export const getProject = (projectId, authToken) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    Axios.get(`/v1/project/${projectId}`, optionAxios)
        .then((res) => {
            dispatch(setCustomer(res.data.project.customer));
            // dispatch(setUtility(res.data.project.utility));
            dispatch(setUtilityAnnualKWH(res.data.project.utility.annualConsumption));
            dispatch(setUtilityEnergyValue(res.data.project.utility.ratePerKwh));
            dispatch(setUtilityProvider(res.data.project.utility.utilityType));
            dispatch(setUtilityAnnualInflation(res.data.project.utility.annualInflationPercentage));
            dispatch(setAFixedCharge(res.data.project.utility.annualFixedCharge));
            dispatch(setProjectAddress(res.data.project.address));
            dispatch(setSolarInputs(res.data.project.solar));
            dispatch(setESS(res.data.project.ess));
            dispatch(setCAP(res.data.project.cap));
            dispatch(setLoan(res.data.project.loan));
            dispatch(setOBS(res.data.project.obs));
            dispatch(setPPA(res.data.project.ppa));
            dispatch(setArchiveStatus(res.data.project.isArchived));
            dispatch(setJobStatus(res.data.project.jobStatus));
            dispatch(setProjectToken(res.data.project.publicToken));
            dispatch(setProjectName(res.data.project.name));
            dispatch(setIncludeCash(res.data.project.includeCash));
            dispatch(setNYRebate(res.data.project.nyserda.nyRebate));
            dispatch(setSMARTValue(res.data.project.smart.incentiveRateInKwh));
            dispatch(setCustomerContact(res.data.project.customer));
            dispatch(setToggleView(true));
            dispatch(setIsLocked(res.data.project.isLocked));
            dispatch(setTaxInputs(res.data.project.taxObligation));
            dispatch(setYearSliderChange(1));
            dispatch(setSalesRep(res.data.project.reps[0]));
            // dispatch(setSGIPValue(res.data.project.sgip.sgipValue));
            // dispatch(setSGIPToggle(res.data.project.sgip.sgipToggle));
        })
        .catch((err) => {
            console.log(err);
        });
};
export const getTokenProject = token => (dispatch) => {
    Axios.get(`/v1/project/token/${token}`)
        .then((res) => {
            dispatch(setCustomer(res.data.project.customer));
            // dispatch(setUtility(res.data.project.utility));
            dispatch(setUtilityAnnualKWH(res.data.project.utility.annualConsumption));
            dispatch(setUtilityEnergyValue(res.data.project.utility.ratePerKwh));
            dispatch(setUtilityProvider(res.data.project.utility.utilityType));
            dispatch(setUtilityAnnualInflation(res.data.project.utility.annualInflationPercentage));
            dispatch(setAFixedCharge(res.data.project.utility.annualFixedCharge));
            dispatch(setProjectAddress(res.data.project.address));
            dispatch(setSolarInputs(res.data.project.solar));
            dispatch(setESS(res.data.project.ess));
            dispatch(setCAP(res.data.project.cap));
            dispatch(setLoan(res.data.project.loan));
            dispatch(setOBS(res.data.project.obs));
            dispatch(setPPA(res.data.project.ppa));
            dispatch(setArchiveStatus(res.data.project.isArchived));
            dispatch(setJobStatus(res.data.project.jobStatus));
            dispatch(setProjectToken(res.data.project.publicToken));
            dispatch(setProjectName(res.data.project.name));
            dispatch(setIncludeCash(res.data.project.includeCash));
            dispatch(setNYRebate(res.data.project.nyserda.nyRebate));
            dispatch(setSMARTValue(res.data.project.smart.incentiveRateInKwh));
            dispatch(setCustomerContact(res.data.project.customer));
            dispatch(setToggleView(true));
            dispatch(setIsLocked(res.data.project.isLocked));
            dispatch(setTaxInputs(res.data.project.taxObligation));
            dispatch(setYearSliderChange(1));
            dispatch(setSalesRep(res.data.project.reps[0]));
            // dispatch(setSGIPValue(res.data.project.sgip.sgipValue));
            // dispatch(setSGIPToggle(res.data.project.sgip.sgipToggle));
        })
        .catch((err) => {
            console.log(err);
        });
};



// WEBPACK FOOTER //
// ./src/containers/common/projects/actions.js